import api from './../../api/api'

export default {

  parts: async (page, take, sortBy, sortOrder, search, filters) => {
    return api.get(`api/parts?page=${page}&take=${take}&sort_by=${sortBy}&sort_order=${sortOrder}&search=${search}&filters=${filters}`)
  },

  createRelatedData: async () => {
    return api.get('api/parts/create')
  },

  create: async part => {
    return api.post('api/parts', part)
  },

  get: async id => {
    return api.get('api/parts/' + id)
  },

  update: async (id,part) => {
    return api.put('api/parts/' + id,part)
  },

  delete: async id => {
    return api.delete('api/parts/' + id)
  },

  partRunningBalance: async (id,from,to) => {
    return api.get(`api/parts/${id}/running-balance?from=${from}&to=${to}`)
  },

  partCredits: async (page, take, sortBy, sortOrder, search, filters) => {
    return api.get(`api/parts/credits?page=${page}&take=${take}&sort_by=${sortBy}&sort_order=${sortOrder}&search=${search}&filters=${filters}`)
  },

  partDebits: async (page, take, sortBy, sortOrder, search, filters) => {
    return api.get(`api/parts/debits?page=${page}&take=${take}&sort_by=${sortBy}&sort_order=${sortOrder}&search=${search}&filters=${filters}`)
  },

  creditCreate: async(credit)=>{
    return api.post(`api/parts/credit`,credit)
  },

  debitCreate: async(debit)=>{
    return api.post(`api/parts/debit`,debit)
  },

  getParts: async (search) => {
    return api.get('api/parts/parts?search='+search)
  },

  requisitionsList: async (page, take, sortBy, sortOrder, search, filters) => {
    return api.get(`api/parts-requisitions?page=${page}&take=${take}&sort_by=${sortBy}&sort_order=${sortOrder}&search=${search}&filters=${filters}`)
  },

  returnsList: async (page, take, sortBy, sortOrder, search, filters) => {
    return api.get(`api/parts-returns?page=${page}&take=${take}&sort_by=${sortBy}&sort_order=${sortOrder}&search=${search}&filters=${filters}`)
  },

  upload: async parts => {
    return api.post(`api/parts/upload/`,parts)
  },
}
